import { render, staticRenderFns } from "./EditQuote.vue?vue&type=template&id=5af3dacc&"
import script from "./EditQuote.vue?vue&type=script&lang=js&"
export * from "./EditQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports